
import { Component, Mixins, Watch } from "vue-property-decorator";
import BaseMixin from "@/views/base/base.mixin";
import Header from "@/views/base/header.vue";
import SidebarContainer from "@/views/sidebar/sidebar-container.vue";

@Component({
  components: {
    Header,
    SidebarContainer
  }
})
export default class BaseComponent extends Mixins(BaseMixin) {
  alertVisible = false;

  get snapshotDisabled() {
    return this.$store.getters['Sidebar/snapshotDisabled'];
  }

  @Watch('$sidebar.isOpen')
  onSidebarOpened(isOpen: boolean) {
    this.$store.commit('Sidebar/setSnapshotDisabled', isOpen);
  }

  @Watch('$sidebar.options.success')
  onSidebarSuccessChanged(newVal: boolean) {
    if (newVal) {
      this.alertVisible = true;
      setTimeout(() => {
        this.alertVisible = false;
      }, 3000);
    }
  }
}
